export const mailAddress = "info@realitybulgaria.pl";
export const phoneNumber = "+48 518 160 166";
export const facebookUrl =
  "https://www.facebook.com/profile.php?id=61559292282667";
